import React from "react";
// Common components
import { DynamicDropdown } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import CancelNavGraph from "./CancelNavGraph";
import {
  CompositionChartCol,
  CompositionChartHeader,
} from "./CompositionChartCol";
// Requests
import {
  getCashAssetDropdown,
  getFundCompositionTable,
} from "src/Requests/goldArbitrage";
// Types
import {
  FundCompositionSearchParams,
  IFundCompositionTableReport,
} from "src/Interfaces/goldArbitrage";
import { IExtraTypeUIProps } from "src/Tables/TableTemplate/tableTemplate";
import { ExtraType } from "src/Interfaces/TableInterfaces";

const FundComposition = () => {
  const [searchParam, setSearchParam] =
    React.useState<FundCompositionSearchParams>(
      {} as FundCompositionSearchParams,
    );

  const fundChangeHandler = (name: string, value: number | string) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  const getExtraTypeUI = ({
    headerName,
    extraType,
    row,
  }: IExtraTypeUIProps<IFundCompositionTableReport>) => {
    if (extraType === ExtraType.WithChart) {
      switch (headerName) {
        case "CancelNav":
          return <CancelNavGraph {...{ row, headerName }} />;
        default:
          return <></>;
      }
    }
    return <></>;
  };

  return (
    <section className="w-full flex flex-col gap-4 ">
      <div className="w-56">
        <DynamicDropdown
          dropdown={{
            name: "instrumentId",
            placeholder: "صندوق",
            extraLabel: true,
          }}
          getData={getCashAssetDropdown}
          onChange={fundChangeHandler}
          value={searchParam.instrumentId}
        />
      </div>
      <div className="w-full max-w-full overflow-x-auto">
        <TableTemplate<FundCompositionSearchParams, IFundCompositionTableReport>
          TableUI={({
            reports,
            onAction,
            sortingType,
            setSortingType,
            scrollKey,
          }) => (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              scrollKey={scrollKey}
              tableBoxClassName="max-h-[550px]"
              getExtraTypeUI={getExtraTypeUI}
              AdditionalBody={{
                getHeader: CompositionChartHeader,
                getRow: ({ row, onAction: rowAction }) => (
                  <CompositionChartCol row={row} onAction={rowAction} />
                ),
              }}
            />
          )}
          getDataTable={getFundCompositionTable}
          searchParameters={searchParam}
          withSort
        />
      </div>
    </section>
  );
};

export default FundComposition;
